'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showSideMenu = showSideMenu;
exports.hideSideMenu = hideSideMenu;

var _constants = require('redux/constants');

function showSideMenu() {
    return {
        type: _constants.HeadInfoConstants.SHOW_SIDEMENU
    };
} /**
   * Created by maximus on 23.11.16.
   */
function hideSideMenu() {
    return {
        type: _constants.HeadInfoConstants.HIDE_SIDEMENU
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/headInfo.js
// module id = 765
// module chunks = 0